import React from "react";
import { func, string } from "prop-types";

import "./search-button.m.css";

const SearchButton = ({ onClick, title }) => (
  <button styleName="button" onClick={onClick}>
    {title}
  </button>
);

SearchButton.propTypes = {
  onClick: func,
  title: string
};

export default SearchButton;
